<template>
  <div class="square_card">
    <div :class="numclass" :id="squareId">
      <svg width="100%" height="100%" class="squared front absolute_center">
        <text fill="#FFFFFF" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" class="rownum">{{ num }}</text>
      </svg>
      <svg width="100%" height="100%" class="squared back absolute_center">
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" class="rownum">{{ num }}</text>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    num: Number,
    type: String
  },
  data () {
    return {
      numclass: this.type + '_' + this.num + ' set_1 square_card',
      squareId: this.type + this.num
    }
  }
}
</script>
